/* eslint-disable no-unneeded-ternary */
import { InvoiceFrequencyType } from 'entities/Invoice';
import { TableFilterType } from 'features/TableFilter';

interface BoxListFilters {
  priceFrom?: number;
  priceTo?: number;
  squareFrom?: number;
  squareTo?: number;
  priceRateType?: InvoiceFrequencyType;
  floorId?: string;
  isAvailable?: boolean;
}

export const transformBoxesListFilters = ({
  priceFrom,
  priceTo,
  priceType,
  squareFrom,
  squareTo,
  floorId,
  availability,
}: TableFilterType): BoxListFilters => {
  return {
    priceFrom: priceFrom?.value || undefined,
    priceTo: priceTo?.value || undefined,
    squareFrom: squareFrom?.value || undefined,
    squareTo: squareTo?.value || undefined,
    priceRateType: priceType?.value || undefined,
    floorId: floorId?.value || undefined,
    isAvailable: availability?.value === undefined || availability?.value === 'available' ? true : false,
  };
};
